// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IIsAccountMaintenanceFeesEnabledPropertyDto } from './IIsAccountMaintenanceFeesEnabledPropertyDto';
import {
    IIsAccountMaintenanceFeesEnabledPropertyDtoFromJSON,
    IIsAccountMaintenanceFeesEnabledPropertyDtoFromJSONTyped,
    IIsAccountMaintenanceFeesEnabledPropertyDtoToJSON,
    IIsAccountMaintenanceFeesEnabledPropertyDtoToJSONTyped,
} from './IIsAccountMaintenanceFeesEnabledPropertyDto';
import type { IAllowContributionsOverElectionAmountDto } from './IAllowContributionsOverElectionAmountDto';
import {
    IAllowContributionsOverElectionAmountDtoFromJSON,
    IAllowContributionsOverElectionAmountDtoFromJSONTyped,
    IAllowContributionsOverElectionAmountDtoToJSON,
    IAllowContributionsOverElectionAmountDtoToJSONTyped,
} from './IAllowContributionsOverElectionAmountDto';
import type { IEoyPlanReconciliationPropertyDto } from './IEoyPlanReconciliationPropertyDto';
import {
    IEoyPlanReconciliationPropertyDtoFromJSON,
    IEoyPlanReconciliationPropertyDtoFromJSONTyped,
    IEoyPlanReconciliationPropertyDtoToJSON,
    IEoyPlanReconciliationPropertyDtoToJSONTyped,
} from './IEoyPlanReconciliationPropertyDto';
import type { IAllowIndividualContributionsPropertyDto } from './IAllowIndividualContributionsPropertyDto';
import {
    IAllowIndividualContributionsPropertyDtoFromJSON,
    IAllowIndividualContributionsPropertyDtoFromJSONTyped,
    IAllowIndividualContributionsPropertyDtoToJSON,
    IAllowIndividualContributionsPropertyDtoToJSONTyped,
} from './IAllowIndividualContributionsPropertyDto';
import type { IMinRolloverAmountPropertyDto } from './IMinRolloverAmountPropertyDto';
import {
    IMinRolloverAmountPropertyDtoFromJSON,
    IMinRolloverAmountPropertyDtoFromJSONTyped,
    IMinRolloverAmountPropertyDtoToJSON,
    IMinRolloverAmountPropertyDtoToJSONTyped,
} from './IMinRolloverAmountPropertyDto';
import type { IIsAutoEnrollmentPropertyDto } from './IIsAutoEnrollmentPropertyDto';
import {
    IIsAutoEnrollmentPropertyDtoFromJSON,
    IIsAutoEnrollmentPropertyDtoFromJSONTyped,
    IIsAutoEnrollmentPropertyDtoToJSON,
    IIsAutoEnrollmentPropertyDtoToJSONTyped,
} from './IIsAutoEnrollmentPropertyDto';
import type { IAllowContributionsAfterAccountClosureDaysPropertyDto } from './IAllowContributionsAfterAccountClosureDaysPropertyDto';
import {
    IAllowContributionsAfterAccountClosureDaysPropertyDtoFromJSON,
    IAllowContributionsAfterAccountClosureDaysPropertyDtoFromJSONTyped,
    IAllowContributionsAfterAccountClosureDaysPropertyDtoToJSON,
    IAllowContributionsAfterAccountClosureDaysPropertyDtoToJSONTyped,
} from './IAllowContributionsAfterAccountClosureDaysPropertyDto';
import type { IContributionMonitoringRequiredDto } from './IContributionMonitoringRequiredDto';
import {
    IContributionMonitoringRequiredDtoFromJSON,
    IContributionMonitoringRequiredDtoFromJSONTyped,
    IContributionMonitoringRequiredDtoToJSON,
    IContributionMonitoringRequiredDtoToJSONTyped,
} from './IContributionMonitoringRequiredDto';
import type { IAccountCreationPropertyDto } from './IAccountCreationPropertyDto';
import {
    IAccountCreationPropertyDtoFromJSON,
    IAccountCreationPropertyDtoFromJSONTyped,
    IAccountCreationPropertyDtoToJSON,
    IAccountCreationPropertyDtoToJSONTyped,
} from './IAccountCreationPropertyDto';
import type { IDaysAfterPlanEndPropertyDto } from './IDaysAfterPlanEndPropertyDto';
import {
    IDaysAfterPlanEndPropertyDtoFromJSON,
    IDaysAfterPlanEndPropertyDtoFromJSONTyped,
    IDaysAfterPlanEndPropertyDtoToJSON,
    IDaysAfterPlanEndPropertyDtoToJSONTyped,
} from './IDaysAfterPlanEndPropertyDto';
import type { IIsPlanLevelFundingDto } from './IIsPlanLevelFundingDto';
import {
    IIsPlanLevelFundingDtoFromJSON,
    IIsPlanLevelFundingDtoFromJSONTyped,
    IIsPlanLevelFundingDtoToJSON,
    IIsPlanLevelFundingDtoToJSONTyped,
} from './IIsPlanLevelFundingDto';
import type { IMaxRolloverAmountPropertyDto } from './IMaxRolloverAmountPropertyDto';
import {
    IMaxRolloverAmountPropertyDtoFromJSON,
    IMaxRolloverAmountPropertyDtoFromJSONTyped,
    IMaxRolloverAmountPropertyDtoToJSON,
    IMaxRolloverAmountPropertyDtoToJSONTyped,
} from './IMaxRolloverAmountPropertyDto';
import type { IPrefundReplenishmentPercentPropertyDto } from './IPrefundReplenishmentPercentPropertyDto';
import {
    IPrefundReplenishmentPercentPropertyDtoFromJSON,
    IPrefundReplenishmentPercentPropertyDtoFromJSONTyped,
    IPrefundReplenishmentPercentPropertyDtoToJSON,
    IPrefundReplenishmentPercentPropertyDtoToJSONTyped,
} from './IPrefundReplenishmentPercentPropertyDto';
import type { IUseHsaCustodianInterestTemplatePropertyDto } from './IUseHsaCustodianInterestTemplatePropertyDto';
import {
    IUseHsaCustodianInterestTemplatePropertyDtoFromJSON,
    IUseHsaCustodianInterestTemplatePropertyDtoFromJSONTyped,
    IUseHsaCustodianInterestTemplatePropertyDtoToJSON,
    IUseHsaCustodianInterestTemplatePropertyDtoToJSONTyped,
} from './IUseHsaCustodianInterestTemplatePropertyDto';
import type { IApplyAccountMaintenanceFeesToPropertyDto } from './IApplyAccountMaintenanceFeesToPropertyDto';
import {
    IApplyAccountMaintenanceFeesToPropertyDtoFromJSON,
    IApplyAccountMaintenanceFeesToPropertyDtoFromJSONTyped,
    IApplyAccountMaintenanceFeesToPropertyDtoToJSON,
    IApplyAccountMaintenanceFeesToPropertyDtoToJSONTyped,
} from './IApplyAccountMaintenanceFeesToPropertyDto';
import type { IEoyPlanReconciliationDelayDaysPropertyDto } from './IEoyPlanReconciliationDelayDaysPropertyDto';
import {
    IEoyPlanReconciliationDelayDaysPropertyDtoFromJSON,
    IEoyPlanReconciliationDelayDaysPropertyDtoFromJSONTyped,
    IEoyPlanReconciliationDelayDaysPropertyDtoToJSON,
    IEoyPlanReconciliationDelayDaysPropertyDtoToJSONTyped,
} from './IEoyPlanReconciliationDelayDaysPropertyDto';
import type { IMinimumContributionAmountDto } from './IMinimumContributionAmountDto';
import {
    IMinimumContributionAmountDtoFromJSON,
    IMinimumContributionAmountDtoFromJSONTyped,
    IMinimumContributionAmountDtoToJSON,
    IMinimumContributionAmountDtoToJSONTyped,
} from './IMinimumContributionAmountDto';
import type { IIsRolloverPropertyDto } from './IIsRolloverPropertyDto';
import {
    IIsRolloverPropertyDtoFromJSON,
    IIsRolloverPropertyDtoFromJSONTyped,
    IIsRolloverPropertyDtoToJSON,
    IIsRolloverPropertyDtoToJSONTyped,
} from './IIsRolloverPropertyDto';
import type { IIsPendContributionsOverIrsDto } from './IIsPendContributionsOverIrsDto';
import {
    IIsPendContributionsOverIrsDtoFromJSON,
    IIsPendContributionsOverIrsDtoFromJSONTyped,
    IIsPendContributionsOverIrsDtoToJSON,
    IIsPendContributionsOverIrsDtoToJSONTyped,
} from './IIsPendContributionsOverIrsDto';
import type { IAllowContributionConfigDto } from './IAllowContributionConfigDto';
import {
    IAllowContributionConfigDtoFromJSON,
    IAllowContributionConfigDtoFromJSONTyped,
    IAllowContributionConfigDtoToJSON,
    IAllowContributionConfigDtoToJSONTyped,
} from './IAllowContributionConfigDto';
import type { IPrefundReplenishmentCreepMinPropertyDto } from './IPrefundReplenishmentCreepMinPropertyDto';
import {
    IPrefundReplenishmentCreepMinPropertyDtoFromJSON,
    IPrefundReplenishmentCreepMinPropertyDtoFromJSONTyped,
    IPrefundReplenishmentCreepMinPropertyDtoToJSON,
    IPrefundReplenishmentCreepMinPropertyDtoToJSONTyped,
} from './IPrefundReplenishmentCreepMinPropertyDto';
import type { IContributionHoldPeriodDaysPropertyDto } from './IContributionHoldPeriodDaysPropertyDto';
import {
    IContributionHoldPeriodDaysPropertyDtoFromJSON,
    IContributionHoldPeriodDaysPropertyDtoFromJSONTyped,
    IContributionHoldPeriodDaysPropertyDtoToJSON,
    IContributionHoldPeriodDaysPropertyDtoToJSONTyped,
} from './IContributionHoldPeriodDaysPropertyDto';
import type { IInterestTemplateIdPropertyDto } from './IInterestTemplateIdPropertyDto';
import {
    IInterestTemplateIdPropertyDtoFromJSON,
    IInterestTemplateIdPropertyDtoFromJSONTyped,
    IInterestTemplateIdPropertyDtoToJSON,
    IInterestTemplateIdPropertyDtoToJSONTyped,
} from './IInterestTemplateIdPropertyDto';
import type { IRolloverClaimsPropertyDto } from './IRolloverClaimsPropertyDto';
import {
    IRolloverClaimsPropertyDtoFromJSON,
    IRolloverClaimsPropertyDtoFromJSONTyped,
    IRolloverClaimsPropertyDtoToJSON,
    IRolloverClaimsPropertyDtoToJSONTyped,
} from './IRolloverClaimsPropertyDto';
import type { IIsForfeitAllowedPropertyDto } from './IIsForfeitAllowedPropertyDto';
import {
    IIsForfeitAllowedPropertyDtoFromJSON,
    IIsForfeitAllowedPropertyDtoFromJSONTyped,
    IIsForfeitAllowedPropertyDtoToJSON,
    IIsForfeitAllowedPropertyDtoToJSONTyped,
} from './IIsForfeitAllowedPropertyDto';
import type { IIsCustomPrefundCalcPropertyDto } from './IIsCustomPrefundCalcPropertyDto';
import {
    IIsCustomPrefundCalcPropertyDtoFromJSON,
    IIsCustomPrefundCalcPropertyDtoFromJSONTyped,
    IIsCustomPrefundCalcPropertyDtoToJSON,
    IIsCustomPrefundCalcPropertyDtoToJSONTyped,
} from './IIsCustomPrefundCalcPropertyDto';
import type { IAccountMaintenanceFeesThresholdPropertyDto } from './IAccountMaintenanceFeesThresholdPropertyDto';
import {
    IAccountMaintenanceFeesThresholdPropertyDtoFromJSON,
    IAccountMaintenanceFeesThresholdPropertyDtoFromJSONTyped,
    IAccountMaintenanceFeesThresholdPropertyDtoToJSON,
    IAccountMaintenanceFeesThresholdPropertyDtoToJSONTyped,
} from './IAccountMaintenanceFeesThresholdPropertyDto';
import type { IPrefundReplenishmentCreepPercentPropertyDto } from './IPrefundReplenishmentCreepPercentPropertyDto';
import {
    IPrefundReplenishmentCreepPercentPropertyDtoFromJSON,
    IPrefundReplenishmentCreepPercentPropertyDtoFromJSONTyped,
    IPrefundReplenishmentCreepPercentPropertyDtoToJSON,
    IPrefundReplenishmentCreepPercentPropertyDtoToJSONTyped,
} from './IPrefundReplenishmentCreepPercentPropertyDto';
import type { IPrefundReplenishmentMinValuePropertyDto } from './IPrefundReplenishmentMinValuePropertyDto';
import {
    IPrefundReplenishmentMinValuePropertyDtoFromJSON,
    IPrefundReplenishmentMinValuePropertyDtoFromJSONTyped,
    IPrefundReplenishmentMinValuePropertyDtoToJSON,
    IPrefundReplenishmentMinValuePropertyDtoToJSONTyped,
} from './IPrefundReplenishmentMinValuePropertyDto';
import type { IForfeitureDaysPropertyDto } from './IForfeitureDaysPropertyDto';
import {
    IForfeitureDaysPropertyDtoFromJSON,
    IForfeitureDaysPropertyDtoFromJSONTyped,
    IForfeitureDaysPropertyDtoToJSON,
    IForfeitureDaysPropertyDtoToJSONTyped,
} from './IForfeitureDaysPropertyDto';
import type { IContributionPushGiveUpDaysPropertyDto } from './IContributionPushGiveUpDaysPropertyDto';
import {
    IContributionPushGiveUpDaysPropertyDtoFromJSON,
    IContributionPushGiveUpDaysPropertyDtoFromJSONTyped,
    IContributionPushGiveUpDaysPropertyDtoToJSON,
    IContributionPushGiveUpDaysPropertyDtoToJSONTyped,
} from './IContributionPushGiveUpDaysPropertyDto';
import type { IBillingMethodTypePropertyDto } from './IBillingMethodTypePropertyDto';
import {
    IBillingMethodTypePropertyDtoFromJSON,
    IBillingMethodTypePropertyDtoFromJSONTyped,
    IBillingMethodTypePropertyDtoToJSON,
    IBillingMethodTypePropertyDtoToJSONTyped,
} from './IBillingMethodTypePropertyDto';
import type { IAccountMaintenanceFeesAmountPropertyDto } from './IAccountMaintenanceFeesAmountPropertyDto';
import {
    IAccountMaintenanceFeesAmountPropertyDtoFromJSON,
    IAccountMaintenanceFeesAmountPropertyDtoFromJSONTyped,
    IAccountMaintenanceFeesAmountPropertyDtoToJSON,
    IAccountMaintenanceFeesAmountPropertyDtoToJSONTyped,
} from './IAccountMaintenanceFeesAmountPropertyDto';

/**
 * 
 * @export
 * @interface IPlanAccountFundingConfigDto
 */
export interface IPlanAccountFundingConfigDto {
    /**
     * 
     * @type {IIsRolloverPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    is_rollover?: IIsRolloverPropertyDto;
    /**
     * 
     * @type {IMaxRolloverAmountPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    max_rollover_amount?: IMaxRolloverAmountPropertyDto;
    /**
     * 
     * @type {IMinRolloverAmountPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    min_rollover_amount?: IMinRolloverAmountPropertyDto;
    /**
     * 
     * @type {IRolloverClaimsPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    rollover_claims?: IRolloverClaimsPropertyDto;
    /**
     * 
     * @type {IIsAutoEnrollmentPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    is_auto_enrollment?: IIsAutoEnrollmentPropertyDto;
    /**
     * 
     * @type {IAllowContributionConfigDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    allow_contribution_config?: IAllowContributionConfigDto;
    /**
     * 
     * @type {IAllowContributionsOverElectionAmountDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    is_allow_contributions_over_election_amount?: IAllowContributionsOverElectionAmountDto;
    /**
     * 
     * @type {IIsPendContributionsOverIrsDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    is_pend_contributions_over_irs?: IIsPendContributionsOverIrsDto;
    /**
     * 
     * @type {IInterestTemplateIdPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    interest_template_id?: IInterestTemplateIdPropertyDto;
    /**
     * 
     * @type {IUseHsaCustodianInterestTemplatePropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    use_hsa_custodian_interest_template?: IUseHsaCustodianInterestTemplatePropertyDto;
    /**
     * 
     * @type {IAccountCreationPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    account_creation?: IAccountCreationPropertyDto;
    /**
     * 
     * @type {IDaysAfterPlanEndPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    days_after_plan_end?: IDaysAfterPlanEndPropertyDto;
    /**
     * 
     * @type {IIsPlanLevelFundingDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    is_plan_level_funding?: IIsPlanLevelFundingDto;
    /**
     * 
     * @type {IContributionMonitoringRequiredDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    contribution_monitoring_required?: IContributionMonitoringRequiredDto;
    /**
     * 
     * @type {number}
     * @memberof IPlanAccountFundingConfigDto
     */
    replenishment_bank_account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanAccountFundingConfigDto
     */
    replenishment_method?: IPlanAccountFundingConfigDtoReplenishmentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanAccountFundingConfigDto
     */
    replenishment_frequency?: IPlanAccountFundingConfigDtoReplenishmentFrequencyEnum;
    /**
     * 
     * @type {number}
     * @memberof IPlanAccountFundingConfigDto
     */
    replenishment_day_number?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanAccountFundingConfigDto
     */
    contribution_bank_account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanAccountFundingConfigDto
     */
    contribution_method?: IPlanAccountFundingConfigDtoContributionMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof IPlanAccountFundingConfigDto
     */
    contribution_hold_period?: number;
    /**
     * 
     * @type {IContributionHoldPeriodDaysPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    contribution_hold_period_days?: IContributionHoldPeriodDaysPropertyDto;
    /**
     * 
     * @type {IContributionPushGiveUpDaysPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    contribution_push_give_up_days?: IContributionPushGiveUpDaysPropertyDto;
    /**
     * 
     * @type {IBillingMethodTypePropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    billing_method_type?: IBillingMethodTypePropertyDto;
    /**
     * 
     * @type {number}
     * @memberof IPlanAccountFundingConfigDto
     */
    external_bank_account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanAccountFundingConfigDto
     */
    external_push_return_account_id?: number;
    /**
     * 
     * @type {IIsCustomPrefundCalcPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    is_custom_prefund_calc?: IIsCustomPrefundCalcPropertyDto;
    /**
     * 
     * @type {IPrefundReplenishmentPercentPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    prefund_replenishment_percent?: IPrefundReplenishmentPercentPropertyDto;
    /**
     * 
     * @type {IPrefundReplenishmentMinValuePropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    prefund_replenishment_min_value?: IPrefundReplenishmentMinValuePropertyDto;
    /**
     * 
     * @type {IPrefundReplenishmentCreepPercentPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    prefund_replenishment_creep_percent?: IPrefundReplenishmentCreepPercentPropertyDto;
    /**
     * 
     * @type {IPrefundReplenishmentCreepMinPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    prefund_replenishment_creep_min?: IPrefundReplenishmentCreepMinPropertyDto;
    /**
     * 
     * @type {IAllowIndividualContributionsPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    allow_individual_contributions?: IAllowIndividualContributionsPropertyDto;
    /**
     * 
     * @type {IMinimumContributionAmountDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    minimum_contribution_amount?: IMinimumContributionAmountDto;
    /**
     * 
     * @type {IIsForfeitAllowedPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    is_forfeit_allowed?: IIsForfeitAllowedPropertyDto;
    /**
     * 
     * @type {IForfeitureDaysPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    forfeiture_days?: IForfeitureDaysPropertyDto;
    /**
     * 
     * @type {IIsAccountMaintenanceFeesEnabledPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    is_account_maintenance_fees_enabled?: IIsAccountMaintenanceFeesEnabledPropertyDto;
    /**
     * 
     * @type {IAccountMaintenanceFeesAmountPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    account_maintenance_fees_amount?: IAccountMaintenanceFeesAmountPropertyDto;
    /**
     * 
     * @type {IApplyAccountMaintenanceFeesToPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    apply_account_maintenance_fees_to?: IApplyAccountMaintenanceFeesToPropertyDto;
    /**
     * 
     * @type {IAccountMaintenanceFeesThresholdPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    account_maintenance_fees_threshold?: IAccountMaintenanceFeesThresholdPropertyDto;
    /**
     * 
     * @type {IAllowContributionsAfterAccountClosureDaysPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    allow_contributions_after_account_closure_days?: IAllowContributionsAfterAccountClosureDaysPropertyDto;
    /**
     * 
     * @type {IEoyPlanReconciliationPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    eoy_plan_reconciliation?: IEoyPlanReconciliationPropertyDto;
    /**
     * 
     * @type {IEoyPlanReconciliationDelayDaysPropertyDto}
     * @memberof IPlanAccountFundingConfigDto
     */
    eoy_plan_reconciliation_delay_days?: IEoyPlanReconciliationDelayDaysPropertyDto;
}

/**
* @export
* @enum {string}
*/
export enum IPlanAccountFundingConfigDtoReplenishmentMethodEnum {
    PULL_FUNDS = 'PULL_FUNDS',
    PUSH_FUNDS = 'PUSH_FUNDS',
    UNDEFINED = 'UNDEFINED'
}
/**
* @export
* @enum {string}
*/
export enum IPlanAccountFundingConfigDtoReplenishmentFrequencyEnum {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY'
}
/**
* @export
* @enum {string}
*/
export enum IPlanAccountFundingConfigDtoContributionMethodEnum {
    PULL_FUNDS = 'PULL_FUNDS',
    PUSH_FUNDS = 'PUSH_FUNDS',
    UNDEFINED = 'UNDEFINED'
}


/**
 * Check if a given object implements the IPlanAccountFundingConfigDto interface.
 */
export function instanceOfIPlanAccountFundingConfigDto(value: object): value is IPlanAccountFundingConfigDto {
    return true;
}

export function IPlanAccountFundingConfigDtoFromJSON(json: any): IPlanAccountFundingConfigDto {
    return IPlanAccountFundingConfigDtoFromJSONTyped(json, false);
}

export function IPlanAccountFundingConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanAccountFundingConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_rollover': json['is_rollover'] == null ? undefined : IIsRolloverPropertyDtoFromJSON(json['is_rollover']),
        'max_rollover_amount': json['max_rollover_amount'] == null ? undefined : IMaxRolloverAmountPropertyDtoFromJSON(json['max_rollover_amount']),
        'min_rollover_amount': json['min_rollover_amount'] == null ? undefined : IMinRolloverAmountPropertyDtoFromJSON(json['min_rollover_amount']),
        'rollover_claims': json['rollover_claims'] == null ? undefined : IRolloverClaimsPropertyDtoFromJSON(json['rollover_claims']),
        'is_auto_enrollment': json['is_auto_enrollment'] == null ? undefined : IIsAutoEnrollmentPropertyDtoFromJSON(json['is_auto_enrollment']),
        'allow_contribution_config': json['allow_contribution_config'] == null ? undefined : IAllowContributionConfigDtoFromJSON(json['allow_contribution_config']),
        'is_allow_contributions_over_election_amount': json['is_allow_contributions_over_election_amount'] == null ? undefined : IAllowContributionsOverElectionAmountDtoFromJSON(json['is_allow_contributions_over_election_amount']),
        'is_pend_contributions_over_irs': json['is_pend_contributions_over_irs'] == null ? undefined : IIsPendContributionsOverIrsDtoFromJSON(json['is_pend_contributions_over_irs']),
        'interest_template_id': json['interest_template_id'] == null ? undefined : IInterestTemplateIdPropertyDtoFromJSON(json['interest_template_id']),
        'use_hsa_custodian_interest_template': json['use_hsa_custodian_interest_template'] == null ? undefined : IUseHsaCustodianInterestTemplatePropertyDtoFromJSON(json['use_hsa_custodian_interest_template']),
        'account_creation': json['account_creation'] == null ? undefined : IAccountCreationPropertyDtoFromJSON(json['account_creation']),
        'days_after_plan_end': json['days_after_plan_end'] == null ? undefined : IDaysAfterPlanEndPropertyDtoFromJSON(json['days_after_plan_end']),
        'is_plan_level_funding': json['is_plan_level_funding'] == null ? undefined : IIsPlanLevelFundingDtoFromJSON(json['is_plan_level_funding']),
        'contribution_monitoring_required': json['contribution_monitoring_required'] == null ? undefined : IContributionMonitoringRequiredDtoFromJSON(json['contribution_monitoring_required']),
        'replenishment_bank_account_id': json['replenishment_bank_account_id'] == null ? undefined : json['replenishment_bank_account_id'],
        'replenishment_method': json['replenishment_method'] == null ? undefined : json['replenishment_method'],
        'replenishment_frequency': json['replenishment_frequency'] == null ? undefined : json['replenishment_frequency'],
        'replenishment_day_number': json['replenishment_day_number'] == null ? undefined : json['replenishment_day_number'],
        'contribution_bank_account_id': json['contribution_bank_account_id'] == null ? undefined : json['contribution_bank_account_id'],
        'contribution_method': json['contribution_method'] == null ? undefined : json['contribution_method'],
        'contribution_hold_period': json['contribution_hold_period'] == null ? undefined : json['contribution_hold_period'],
        'contribution_hold_period_days': json['contribution_hold_period_days'] == null ? undefined : IContributionHoldPeriodDaysPropertyDtoFromJSON(json['contribution_hold_period_days']),
        'contribution_push_give_up_days': json['contribution_push_give_up_days'] == null ? undefined : IContributionPushGiveUpDaysPropertyDtoFromJSON(json['contribution_push_give_up_days']),
        'billing_method_type': json['billing_method_type'] == null ? undefined : IBillingMethodTypePropertyDtoFromJSON(json['billing_method_type']),
        'external_bank_account_id': json['external_bank_account_id'] == null ? undefined : json['external_bank_account_id'],
        'external_push_return_account_id': json['external_push_return_account_id'] == null ? undefined : json['external_push_return_account_id'],
        'is_custom_prefund_calc': json['is_custom_prefund_calc'] == null ? undefined : IIsCustomPrefundCalcPropertyDtoFromJSON(json['is_custom_prefund_calc']),
        'prefund_replenishment_percent': json['prefund_replenishment_percent'] == null ? undefined : IPrefundReplenishmentPercentPropertyDtoFromJSON(json['prefund_replenishment_percent']),
        'prefund_replenishment_min_value': json['prefund_replenishment_min_value'] == null ? undefined : IPrefundReplenishmentMinValuePropertyDtoFromJSON(json['prefund_replenishment_min_value']),
        'prefund_replenishment_creep_percent': json['prefund_replenishment_creep_percent'] == null ? undefined : IPrefundReplenishmentCreepPercentPropertyDtoFromJSON(json['prefund_replenishment_creep_percent']),
        'prefund_replenishment_creep_min': json['prefund_replenishment_creep_min'] == null ? undefined : IPrefundReplenishmentCreepMinPropertyDtoFromJSON(json['prefund_replenishment_creep_min']),
        'allow_individual_contributions': json['allow_individual_contributions'] == null ? undefined : IAllowIndividualContributionsPropertyDtoFromJSON(json['allow_individual_contributions']),
        'minimum_contribution_amount': json['minimum_contribution_amount'] == null ? undefined : IMinimumContributionAmountDtoFromJSON(json['minimum_contribution_amount']),
        'is_forfeit_allowed': json['is_forfeit_allowed'] == null ? undefined : IIsForfeitAllowedPropertyDtoFromJSON(json['is_forfeit_allowed']),
        'forfeiture_days': json['forfeiture_days'] == null ? undefined : IForfeitureDaysPropertyDtoFromJSON(json['forfeiture_days']),
        'is_account_maintenance_fees_enabled': json['is_account_maintenance_fees_enabled'] == null ? undefined : IIsAccountMaintenanceFeesEnabledPropertyDtoFromJSON(json['is_account_maintenance_fees_enabled']),
        'account_maintenance_fees_amount': json['account_maintenance_fees_amount'] == null ? undefined : IAccountMaintenanceFeesAmountPropertyDtoFromJSON(json['account_maintenance_fees_amount']),
        'apply_account_maintenance_fees_to': json['apply_account_maintenance_fees_to'] == null ? undefined : IApplyAccountMaintenanceFeesToPropertyDtoFromJSON(json['apply_account_maintenance_fees_to']),
        'account_maintenance_fees_threshold': json['account_maintenance_fees_threshold'] == null ? undefined : IAccountMaintenanceFeesThresholdPropertyDtoFromJSON(json['account_maintenance_fees_threshold']),
        'allow_contributions_after_account_closure_days': json['allow_contributions_after_account_closure_days'] == null ? undefined : IAllowContributionsAfterAccountClosureDaysPropertyDtoFromJSON(json['allow_contributions_after_account_closure_days']),
        'eoy_plan_reconciliation': json['eoy_plan_reconciliation'] == null ? undefined : IEoyPlanReconciliationPropertyDtoFromJSON(json['eoy_plan_reconciliation']),
        'eoy_plan_reconciliation_delay_days': json['eoy_plan_reconciliation_delay_days'] == null ? undefined : IEoyPlanReconciliationDelayDaysPropertyDtoFromJSON(json['eoy_plan_reconciliation_delay_days']),
    };
}

export function IPlanAccountFundingConfigDtoToJSON(json: any): IPlanAccountFundingConfigDto {
    return IPlanAccountFundingConfigDtoToJSONTyped(json, false);
}

export function IPlanAccountFundingConfigDtoToJSONTyped(value?: IPlanAccountFundingConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_rollover': IIsRolloverPropertyDtoToJSON(value['is_rollover']),
        'max_rollover_amount': IMaxRolloverAmountPropertyDtoToJSON(value['max_rollover_amount']),
        'min_rollover_amount': IMinRolloverAmountPropertyDtoToJSON(value['min_rollover_amount']),
        'rollover_claims': IRolloverClaimsPropertyDtoToJSON(value['rollover_claims']),
        'is_auto_enrollment': IIsAutoEnrollmentPropertyDtoToJSON(value['is_auto_enrollment']),
        'allow_contribution_config': IAllowContributionConfigDtoToJSON(value['allow_contribution_config']),
        'is_allow_contributions_over_election_amount': IAllowContributionsOverElectionAmountDtoToJSON(value['is_allow_contributions_over_election_amount']),
        'is_pend_contributions_over_irs': IIsPendContributionsOverIrsDtoToJSON(value['is_pend_contributions_over_irs']),
        'interest_template_id': IInterestTemplateIdPropertyDtoToJSON(value['interest_template_id']),
        'use_hsa_custodian_interest_template': IUseHsaCustodianInterestTemplatePropertyDtoToJSON(value['use_hsa_custodian_interest_template']),
        'account_creation': IAccountCreationPropertyDtoToJSON(value['account_creation']),
        'days_after_plan_end': IDaysAfterPlanEndPropertyDtoToJSON(value['days_after_plan_end']),
        'is_plan_level_funding': IIsPlanLevelFundingDtoToJSON(value['is_plan_level_funding']),
        'contribution_monitoring_required': IContributionMonitoringRequiredDtoToJSON(value['contribution_monitoring_required']),
        'replenishment_bank_account_id': value['replenishment_bank_account_id'],
        'replenishment_method': value['replenishment_method'],
        'replenishment_frequency': value['replenishment_frequency'],
        'replenishment_day_number': value['replenishment_day_number'],
        'contribution_bank_account_id': value['contribution_bank_account_id'],
        'contribution_method': value['contribution_method'],
        'contribution_hold_period': value['contribution_hold_period'],
        'contribution_hold_period_days': IContributionHoldPeriodDaysPropertyDtoToJSON(value['contribution_hold_period_days']),
        'contribution_push_give_up_days': IContributionPushGiveUpDaysPropertyDtoToJSON(value['contribution_push_give_up_days']),
        'billing_method_type': IBillingMethodTypePropertyDtoToJSON(value['billing_method_type']),
        'external_bank_account_id': value['external_bank_account_id'],
        'external_push_return_account_id': value['external_push_return_account_id'],
        'is_custom_prefund_calc': IIsCustomPrefundCalcPropertyDtoToJSON(value['is_custom_prefund_calc']),
        'prefund_replenishment_percent': IPrefundReplenishmentPercentPropertyDtoToJSON(value['prefund_replenishment_percent']),
        'prefund_replenishment_min_value': IPrefundReplenishmentMinValuePropertyDtoToJSON(value['prefund_replenishment_min_value']),
        'prefund_replenishment_creep_percent': IPrefundReplenishmentCreepPercentPropertyDtoToJSON(value['prefund_replenishment_creep_percent']),
        'prefund_replenishment_creep_min': IPrefundReplenishmentCreepMinPropertyDtoToJSON(value['prefund_replenishment_creep_min']),
        'allow_individual_contributions': IAllowIndividualContributionsPropertyDtoToJSON(value['allow_individual_contributions']),
        'minimum_contribution_amount': IMinimumContributionAmountDtoToJSON(value['minimum_contribution_amount']),
        'is_forfeit_allowed': IIsForfeitAllowedPropertyDtoToJSON(value['is_forfeit_allowed']),
        'forfeiture_days': IForfeitureDaysPropertyDtoToJSON(value['forfeiture_days']),
        'is_account_maintenance_fees_enabled': IIsAccountMaintenanceFeesEnabledPropertyDtoToJSON(value['is_account_maintenance_fees_enabled']),
        'account_maintenance_fees_amount': IAccountMaintenanceFeesAmountPropertyDtoToJSON(value['account_maintenance_fees_amount']),
        'apply_account_maintenance_fees_to': IApplyAccountMaintenanceFeesToPropertyDtoToJSON(value['apply_account_maintenance_fees_to']),
        'account_maintenance_fees_threshold': IAccountMaintenanceFeesThresholdPropertyDtoToJSON(value['account_maintenance_fees_threshold']),
        'allow_contributions_after_account_closure_days': IAllowContributionsAfterAccountClosureDaysPropertyDtoToJSON(value['allow_contributions_after_account_closure_days']),
        'eoy_plan_reconciliation': IEoyPlanReconciliationPropertyDtoToJSON(value['eoy_plan_reconciliation']),
        'eoy_plan_reconciliation_delay_days': IEoyPlanReconciliationDelayDaysPropertyDtoToJSON(value['eoy_plan_reconciliation_delay_days']),
    };
}

